const testimonials = [
  {
    name: "Patricia W.",
    location: "Quincy, FL",
    rating: 5,
    text: "I had a family emergency and needed to get to Jamaica within 4 days. I live in Quincy and had no idea where to start. Fast Passport Center made it so simple — ship overnight from Tallahassee and they handled everything. Got my passport in 3 days. I cannot thank them enough.",
    service: "Emergency Passport",
  },
  {
    name: "James R.",
    location: "Havana, FL",
    rating: 5,
    text: "My passport expired right before a business trip to Canada. Living in a small town like Havana, I figured I'd have to drive to Atlanta. Nope — FPC had me ship from home and got my renewal back in 5 business days. Professional, fast, and way easier than I expected.",
    service: "Passport Renewal",
  },
  {
    name: "Angela M.",
    location: "Chattahoochee, FL",
    rating: 5,
    text: "Our daughter needed her first passport for a school trip to Europe. We were worried about the process since we're in Chattahoochee with limited options nearby. FPC walked us through every step, told us exactly which clerk to visit in Quincy, and got her passport back in 7 days. Amazing service for a rural area.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function QuincyTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Quincy Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Quincy, Havana, Chattahoochee, and Gadsden County who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}